<div>
    <h2 class="mat-title">
        Dual Enrollment Course Adoption Request Form
    </h2>
    <div>
        This form can be used to request that a college course be considered for adoption for Dual Enrollment at the Polk County Public Schools system. You must fill in all required elements of this request form in order to submit your request. Once all required information has been provided in the request form, click the "Submit Request" button to send your course adoption request to the district.</div>
    <!-- <button mat-raised-button color="primary" (click)="ShowCourseSearch()">Search Courses</button> -->

    <!-- New Course Form -->
    <div class="mat-elevation-z12 padding margintop">
        <h2 class="mat-headline">Course Adoption Request Form</h2>
        <form [formGroup]="NewCourseForm" novalidate class="margintop" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.gt-md="25px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="start stretch">
                <!-- <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label>Course Prefix: </form-label>
                    <mat-form-field fxFlex.lt-md floatLabel="never">
                        <input type="text" matInput formControlName="Prefix" placeholder="Prefix..." maxlength="3" />
                        <mat-hint>Examples: ENC, MAC, PHY</mat-hint>
                        <mat-error *ngIf="NewCourseForm.controls['Prefix'].hasError('required')">Course prefix required</mat-error>
                    </mat-form-field>
                </div> -->
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label>Course Code: </form-label>
                    <mat-form-field fxFlex.lt-md floatLabel="never">
                        <input type="text" class="codeinput" matInput formControlName="Code" placeholder="Code..." maxlength="8" />
                        <mat-hint>Please provide all 8 characters.</mat-hint>
                        <mat-error *ngIf="NewCourseForm.controls['Code'].hasError('required')">Course code required</mat-error>
                        <mat-error *ngIf="NewCourseForm.controls['Code'].hasError('minlength') || NewCourseForm.controls['Code'].hasError('maxlength')">Course code must be 8 characters.</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label>Course Name/Title: </form-label>
                    <mat-form-field fxFlex.lt-md floatLabel="never">
                        <input type="text" matInput formControlName="Name" placeholder="Name/Title..." maxlength="150" />
                        <mat-hint>Example: College Composition I</mat-hint>
                        <mat-error *ngIf="NewCourseForm.controls['Name'].hasError('required')">Course name/title required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap.gt-md="25px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="start stretch">
                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label>Proposed Use: </form-label>
                    <mat-radio-group formControlName="ProposedUseID" fxLayout="column" fxLayoutAlign="start stretch" fxFlex>
                        <mat-radio-button [value]="0">Standard</mat-radio-button>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                            <mat-radio-button [value]="1">Other: </mat-radio-button>
                            <mat-form-field floatLabel="never" fxFlex>
                                <input type="text" matInput formControlName="ProposedUseDescription" placeholder="Explain..." />
                                <mat-error *ngIf="NewCourseForm.controls['ProposedUseDescription'].hasError('required')">Proposed use description required</mat-error>
                            </mat-form-field>
                        </div>
                    </mat-radio-group>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label>Program: </form-label>
                    <mat-form-field fxFlex.lt-md floatLabel="never" class="wideselect thinform">
                        <mat-select formControlName="GradRequirement" placeholder="Program..." aria-label="Program Selection List">
                            <mat-option>Program...</mat-option>
                            <mat-option *ngFor="let pgm of GradRequirements" [value]="pgm">{{pgm.Name}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="NewCourseForm.controls['GradRequirement'].hasError('required')">Program required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label>High School Credits: </form-label>
                    <mat-radio-group formControlName="HSCredit" fxLayout="column" fxLayoutAlign="start start">
                        <mat-radio-button [value]="0.5">0.5</mat-radio-button>
                        <mat-radio-button [value]="1.0">1.0</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <!-- <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.gt-md="25px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="start stretch">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label>Modifications Needed: </form-label>
                    <mat-form-field fxFlex.lt-md floatLabel="never">
                        <textarea matInput #mdtext formControlName="ModificationsNeeded" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="5" placeholder="Enter text..."></textarea>
                        <mat-hint align="end">{{mdtext.value?.length}}/1000</mat-hint>
                        <mat-error *ngIf="NewCourseForm.controls['ModificationsNeeded'].hasError('required')">Modifications needed required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label>Companion Fields Needed: </form-label>
                    <mat-form-field fxFlex.lt-md floatLabel="never">
                        <textarea matInput #cfntext formControlName="CompanionFieldsNeeded" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="5" placeholder="Enter text..."></textarea>
                        <mat-hint align="end">{{cfntext.value?.length}}/1000</mat-hint>
                        <mat-error *ngIf="NewCourseForm.controls['CompanionFieldsNeeded'].hasError('required')">Companion fields needed required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label fxFlex.gt-sm="33">Reason for Specific Companion Code Requested: </form-label>
                    <mat-form-field fxFlex floatLabel="never">
                        <textarea matInput #cfrtext formControlName="CompanionFieldsReason" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="5" placeholder="Enter text..."></textarea>
                        <mat-hint align="end">{{cfrtext.value?.length}}/2000</mat-hint>
                        <mat-error *ngIf="NewCourseForm.controls['CompanionFieldsReason'].hasError('required')">Companion code reason required</mat-error>
                    </mat-form-field>
                </div>
            </div> -->
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap.gt-md="25px" fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="start stretch">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label>School Year Requested: </form-label>
                    <mat-form-field fxFlex.lt-md floatLabel="never" class="wideselect">
                        <mat-select formControlName="SchoolYear" placeholder="Select Year..." aria-label="School Year Selection List">
                            <mat-option>Select Year...</mat-option>
                            <mat-option *ngFor="let year of AvailableSchoolYears" [value]="year">{{year | schoolYear}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="NewCourseForm.controls['SchoolYear'].hasError('required')">School year required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="33" fxFlex.lt-md="100">
                    <form-label>School: </form-label>
                    <mat-form-field fxFlex.lt-md floatLabel="never" class="wideselect">
                        <mat-select formControlName="School" placeholder="Select School..." aria-label="School Selection List">
                            <mat-option>Select School...</mat-option>
                            <mat-option *ngFor="let sch of AvailableSchools" [value]="sch">{{sch.SchoolName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="NewCourseForm.controls['School'].hasError('required')">School required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center">
                <app-tags
                    #newTag
                    [options]="TagOptions"
                    [tagData]="[]"
                    [control]="this.NewCourseForm.get('CollegeIDs')"
                    [tagType]="TagTypes.College"
                    [isVertical]="false"
                    [showAddLabel]="true"
                >
                </app-tags>
                <mat-error *ngIf="(newTag.control.touched || newTag.control.dirty) && (!newTag.control.value?.length || newTag.control.value?.length === 0)">
                    Please select at least 1 college
                </mat-error>
            </div>
        </form>
        <div class="actionbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
            <button type="text" mat-raised-button color="primary" (click)="AddNewRequest(newTag.control)" [disabled]="NewCourseForm.invalid || !newTag.control.value?.length || newTag.control.value?.length === 0">Submit Request</button>
            <button type="text" mat-raised-button color="warn" (click)="ResetNewCourseForm(newTag.control)">Clear Form</button>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/adoptionrequest/adoptionrequest.component.html